import * as moment from 'moment-timezone';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class AlertResultDto {
    alertID: number;
    priority: string;
    @Type(() => Date)
    createdOn: Date;
    @Type(() => UserNameDisplayResultDto)
    createdBy: UserNameDisplayResultDto;
    @Type(() => Date)
    effectiveDate: Date;
    expireAfterDays: number;
    subject: string;
    text: string;
    @Type(() => Date)
    modifiedOn: Date;
    isCurrent: boolean;
    isFuture: boolean;
    isPast: boolean;
    allowEdit: boolean;

    get endDate(): Date {
        if (this.expireAfterDays !== 99999) {
            return moment(this.effectiveDate).add(this.expireAfterDays, 'days').toDate();
        }
        return null;
    }
}
